module.exports = __webpack_public_path__ + "static/img/Frame(9).87f5380b.png";